import axios from 'axios'

const API_PATH = 'api/v2/admins/scrapers/websites'

const ScraperWebsitesApiV2 = {
  get: async () => {
    const response = await axios.get(API_PATH)
    return response
  }
}

export default ScraperWebsitesApiV2
